'use strict';

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from "mobx-react";
import Loader from "@uw-it-sis/lib-react/lib/Loader";

import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import {States} from "@uw-it-sis/lib-react/lib/AppConstants";
import HelpPopover from "@uw-it-sis/lib-react/lib/HelpPopover";

import pinnedSchedulesStore from './PinnedSchedulesStore';
import PinnedScheduleOption from "./PinnedScheduleOption";

class PinnedSchedules extends Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.store = pinnedSchedulesStore;

        this.closeErrorModal = this.closeErrorModal.bind(this);
    }

    closeErrorModal() {
        this.store.closeErrorModal();
    }

    render() {
        let pinnedSchedulesData = this.store.getPinnedSchedules();
        let pinnedSchedules = <p>Save any schedule options for later by pinning it. Any combination of courses and sections from schedule options can be pinned here up to 3.</p>;

        if (pinnedSchedulesData.length > 0) {
            pinnedSchedules =
                <ListGroup>
                    {
                        pinnedSchedulesData.map((item, index) => {
                            return (
                                <PinnedScheduleOption schedule={item}
                                                      number={index + 1}
                                                      key={index}
                                                      regDate={this.props.regDate}  />
                            );
                        })
                    }
                </ListGroup>
        }

        const loaderSpinner = <Spinner
            as="span"
            size="sm"
            animation="border"
            role="status"
            aria-hidden="true"
        />;

        let pinnedSchedulesErrorModal;
        if (this.store.showErrorModal) {
            pinnedSchedulesErrorModal =
                <Modal show={this.store.showErrorModal}
                       size="sm"
                       onHide={this.closeErrorModal}
                       aria-labelledby="max-pinned-schedules-modal"
                       centered>
                    <Modal.Header closeButton>
                        <Modal.Title id="max-pinned-schedules-modal">Maximum Pinned Schedules Reached</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>You've pinned the maximum number of schedules. You can pin up to three
                            possible schedules for this quarter. To add another, you'll first need
                            to remove one of the schedules you've already pinned.
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.closeErrorModal}>Close</Button>
                    </Modal.Footer>
                </Modal>;
        }

        return (
            <>
                <Card border="border scheduleBuilder-pinned">
                    <Card.Header className="d-flex align-items-center">
                        <h3 className="h4 mb-0">Pinned Schedules</h3>
                        <div className="ms-auto">
                            <HelpPopover title="Pinned Schedules" placement="left">
                                Pinning a schedule allows you to save your favorite schedule options in Schedule Builder
                                without affecting your plan. You can pin up to 3 schedule options for future planning.
                            </HelpPopover>
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <Loader show={this.store.state === States.pending} message={loaderSpinner} contentBlur={1} disableDefaultStyles>
                            {pinnedSchedules}
                        </Loader>
                    </Card.Body>
                </Card>
                {pinnedSchedulesErrorModal}
            </>
        );
    }
}
PinnedSchedules.propTypes = {
    regDate: PropTypes.string.isRequired
}
export default observer(PinnedSchedules);